import Logout from "@components/Logout";
import {
  ROUTING_ADMIN_CLIENT_EXTERNAL_EFFECTS,
  ROUTING_ADMIN_CLIENT_MODELS,
  ROUTING_ADMIN_USERS
} from "@constants/adminPanelRouting";
import { BUTTON_PRIMARY_ICON_FONT_SIZE } from "@constants/button";
import ROUTES from "@constants/routing";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import PeopleIcon from "@mui/icons-material/People";
import ScienceIcon from "@mui/icons-material/Science";
import StoreIcon from "@mui/icons-material/Store";
import ThunderstormIcon from "@mui/icons-material/Thunderstorm";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export interface AdminPanelNavBarProps {
  activeTab: "clients" | "users" | "models" | "externalEffects";
  onGoBack?: () => void;
}

const activeTabStyle = {
  backgroundColor: "white"
};

const inactiveTabStyle = {
  border: "1px solid #ffffff",
  "&:hover": { backgroundColor: "white" }
};

const AdminPanelNavBar = ({ activeTab, onGoBack }: AdminPanelNavBarProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onGoBackHome = () => {
    navigate(ROUTES.HOME);
  };

  const onClientsClick = () => {
    navigate(`${ROUTES.ADMIN_PANEL}`);
  };

  const onUsersClick = () => {
    navigate(`${ROUTES.ADMIN_PANEL}${ROUTING_ADMIN_USERS}`);
  };

  const onExternalEffectsClick = () => {
    navigate(`${ROUTES.ADMIN_PANEL}${ROUTING_ADMIN_CLIENT_EXTERNAL_EFFECTS}`);
  };

  const onModelsClick = () => {
    navigate(`${ROUTES.ADMIN_PANEL}${ROUTING_ADMIN_CLIENT_MODELS}`);
  };

  return (
    <Box className=" w-full flex justify-between">
      <Box className="justify-start">
        <IconButton
          color="info"
          style={{ backgroundColor: "white" }}
          onClick={onGoBack || onGoBackHome}
        >
          <ArrowBackIosNewIcon />
        </IconButton>
      </Box>
      <Box className="justify-start flex gap-2">
        <Tooltip title={t("admin.clients.title")}>
          <IconButton
            color="info"
            onClick={onClientsClick}
            style={activeTab === "clients" ? activeTabStyle : inactiveTabStyle}
          >
            <StoreIcon sx={{ fontSize: BUTTON_PRIMARY_ICON_FONT_SIZE }} />
          </IconButton>
        </Tooltip>
        <Tooltip title={t("common.users")}>
          <IconButton
            color="info"
            onClick={onUsersClick}
            sx={activeTab === "users" ? activeTabStyle : inactiveTabStyle}
          >
            <PeopleIcon sx={{ fontSize: BUTTON_PRIMARY_ICON_FONT_SIZE }} />
          </IconButton>
        </Tooltip>
        <Tooltip title={t("common.clientModels")}>
          <IconButton
            color="info"
            onClick={onModelsClick}
            sx={activeTab === "models" ? activeTabStyle : inactiveTabStyle}
          >
            <ScienceIcon sx={{ fontSize: BUTTON_PRIMARY_ICON_FONT_SIZE }} />
          </IconButton>
        </Tooltip>
        <Tooltip title={t("common.clientExternalEffects")}>
          <IconButton
            color="info"
            onClick={onExternalEffectsClick}
            sx={
              activeTab === "externalEffects"
                ? activeTabStyle
                : inactiveTabStyle
            }
          >
            <ThunderstormIcon
              sx={{ fontSize: BUTTON_PRIMARY_ICON_FONT_SIZE }}
            />
          </IconButton>
        </Tooltip>
      </Box>
      <Box className="justify-end">
        <Logout />
      </Box>
    </Box>
  );
};

export default AdminPanelNavBar;
